"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dequeue = void 0;
var Dequeue = /*#__PURE__*/function () {
  function Dequeue() {
    _classCallCheck(this, Dequeue);
    this._length = 0;
    this.head = undefined;
    this.tail = undefined;
  }
  _createClass(Dequeue, [{
    key: "length",
    get: function get() {
      return this._length;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = undefined;
      this._length = 0;
    }
  }, {
    key: "push",
    value: function push(value) {
      var newNode = {
        value: value,
        prev: this.tail,
        next: undefined
      };
      if (this._length) {
        this.tail.next = newNode;
        this.tail = newNode;
      } else {
        this.head = this.tail = newNode;
      }
      this._length++;
    }
  }, {
    key: "pop",
    value: function pop() {
      if (!this._length) {
        return undefined;
      }
      var result = this.tail;
      this.tail = this.tail.prev;
      this._length--;
      if (!this._length) {
        this.head = this.tail = undefined;
      }
      return result.value;
    }
  }, {
    key: "unshift",
    value: function unshift(value) {
      var newNode = {
        value: value,
        prev: undefined,
        next: this.head
      };
      if (this._length) {
        this.head.prev = newNode;
        this.head = newNode;
      } else {
        this.head = this.tail = newNode;
      }
      this._length++;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (!this._length) {
        return undefined;
      }
      var result = this.head;
      this.head = this.head.next;
      this._length--;
      if (!this._length) {
        this.head = this.tail = undefined;
      }
      return result.value;
    }
  }, {
    key: "peekFront",
    value: function peekFront() {
      if (this._length) {
        return this.head.value;
      }
      return undefined;
    }
  }, {
    key: "peekBack",
    value: function peekBack() {
      if (this._length) {
        return this.tail.value;
      }
      return undefined;
    }
  }]);
  return Dequeue;
}();
exports.Dequeue = Dequeue;